<template>
    <div v-click-outside='outsideClick' class='ui-time'>
        <button :disabled='disabled' class='btn' type='button' @click='open = !open'>
            {{ buttonTxt }}
        </button>
        <div v-show='open' class='time-wrap'>
            <b-time v-model='bindTime' :minutes-step='stepMinutes' locale='de' @context='onContext'></b-time>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimeSelect',
    props: {
        time: {
            default: '00:00:00',
            type: String,
        },
        stepMinutes: {
            default: 1,
            type: Number,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            buttonTxt: '',
            bindTime: '',
            context: null,
            open: false,
        };
    },
    watch: {
        time(v) {
            this.bindTime = v;
        },
    },
    mounted() {
        this.bindTime = this.time;
    },
    created() {
    },
    methods: {
        onContext: function(ctx) {
            this.buttonTxt = ctx.formatted;

            this.$emit('update:time', ctx.value);
        },
        outsideClick() {
            this.open = false;
        },
    },
};
</script>
<style lang='scss' scoped></style>
